// extracted by mini-css-extract-plugin
export default {"a0":"ViewAllSuggestions-cls1_VOe","a1":"ViewAllSuggestions-cls1_EzF","cls1":"ViewAllSuggestions-cls1_A8g","cls2":"ViewAllSuggestions-cls2_aob ViewAllSuggestions-cls1_A8g"};